import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'

export const StyledTopBar = styled.div`
  @media screen and (max-width: ${BREAKPOINT.MD - 1}px) {
    display: none;
  }
`
